module.exports = __webpack_public_path__ + "img/reserve-shop-reservation.25dcc094.webp";